import { useMemo } from "react";

import { useCustomGoalsContext } from "@components/data/custom-goals-provider";
import { useUser } from "@components/user-context";
import { useCustomMetricsContext } from "@features/custom-metrics/hooks/custom-metrics-provider";
import { useFeatureFlags } from "@hooks/http";
import { useUserAttributionSettings } from "@hooks/use-user-attribution-settings";
import { getMetrics } from "@north-beam/nb-client-side/metrics-v2";
import { type ITimeGranularityV2 } from "@north-beam/nb-common";

export const useMetrics = (timeGranularity: ITimeGranularityV2) => {
  const { user } = useUser();
  const { hasFeatureFlag } = useFeatureFlags();

  const { attributionModel, attributionWindow, accountingMode } =
    useUserAttributionSettings();

  const { customGoals } = useCustomGoalsContext();
  const { customMetrics } = useCustomMetricsContext();

  const metrics = useMemo(() => {
    return getMetrics({
      user,
      attributionModel,
      attributionWindow,
      accountingMode,
      timeGranularity,
      customGoalRows: customGoals,
      customMetricRows: customMetrics,
      showV1Forecasts: hasFeatureFlag("showV1Forecasts"),
    });
  }, [
    user,
    attributionModel,
    attributionWindow,
    accountingMode,
    timeGranularity,
    customGoals,
    customMetrics,
    hasFeatureFlag,
  ]);

  return { metrics };
};
